import { AlertTriangle, Clock } from "lucide-react";
import { useI18n } from "../../i18n";
import { fmtDateTime } from "../../lib/format";

// "Last scheduled sync" line; turns into a red warning when no cron-triggered sync succeeded in the last 2 hours.
export const ScheduledSyncNote = ({ s }) => {
  const { t } = useI18n();
  if (!s) return null;
  const when = s.last_success_at ? fmtDateTime(s.last_success_at) : t("x.dash.schedNever");
  const call = s.last_call;
  const callState = call ? (call.accepted ? t("x.dash.schedAccepted") : t("x.dash.schedRejected", { reason: call.reason || "" })) : "—";
  return (
    <div role={s.stale ? "alert" : undefined} data-testid="scheduled-sync-note" data-stale={s.stale ? "true" : "false"}
      className={`flex flex-wrap items-start gap-2 rounded-2xl px-4 py-3 text-sm ${s.stale ? "bg-red-50 text-red-800 ring-1 ring-red-200" : "bg-white text-slate-600 shadow-sm"}`}>
      {s.stale ? <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" /> : <Clock className="mt-0.5 h-4 w-4 shrink-0 text-slate-400" />}
      <div className="min-w-0 flex-1">
        <p className="font-medium">{t(s.stale ? "x.dash.schedStale" : "x.dash.schedOk", { when })}</p>
        <p className="text-xs opacity-80" data-testid="scheduled-sync-last-call">{t("x.dash.schedLastCall", { when: call ? fmtDateTime(call.received_at) : "—", state: callState })}</p>
      </div>
    </div>
  );
};
